<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="3"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dział Rozliczenia</span>
        <h3 class="page-title">Lista rozliczeń</h3>
      </d-col>
      <d-col
        col
        sm="9"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="primary"
          class="mr-2"
          :class="{isLoading: submitting.WEEKLY}"
          @click.prevent="generateSettlement('WEEKLY')">
          <i class="material-icons">text_snippet</i>
          Generuj rozliczenia tygodniowe
        </d-button>
        <d-button
          theme="primary"
          class="mr-2"
          :class="{isLoading: submitting.MONTHLY}"
          @click.prevent="generateSettlement('MONTHLY')">
          <i class="material-icons">text_snippet</i>
          Generuj rozliczenia miesięczne
        </d-button>
        <d-button
          theme="primary"
          class="mr-2"
          :class="{isLoading: submitting.integrate}"
          @click.prevent="integrateInvoices()">
          <i class="material-icons">text_snippet</i>
          Wystaw faktury
        </d-button>
        <d-button
          theme="success"
          @click.prevent="openModal">
          <i class="material-icons">add</i>
          Przyjmij wpłatę
        </d-button>
      </d-col>
    </d-row>
    <settlements-payment
      :key="key_payment_module"
      :close-modal="closeModal"
      :show-modal="show_payment_module"/>
    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="settlements-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj numer faktury"
          type="text"
          v-model="filters.number" />
        <v-select
          class="ml-2 w-100"
          :options="paymentMethods"
          :reduce="payment => payment.id"
          v-model="filters.payment_type"
          placeholder="Rodzaj płatności"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          class="ml-2 w-100"
          :options="monthsList"
          :reduce="months => months.id"
          v-model="filters.month"
          placeholder="Wybierz miesiąc"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <date-picker
          valueType="format"
          class="ml-2"
          type="year"
          style="width: 100%"
          v-model="filters.year"
          :placeholder="'Wybierz rok'"/>
        <filter-autocomplete
          v-model="filters.customer_id"
          style="width: 100%"
          class="ml-2"
          :endpoint-items="'/customers/items'"
          :data-id="filters.customer_id"
          :reduce="obj => obj.id"
          :endpoint-item="'/customers/item/'"
          :placeholder="'Wybierz klienta'"/>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">Numer faktury</th>
            <th
              scope="col"
              class="border-0">Klient</th>
            <th
              scope="col"
              class="border-0">Data wystawienia</th>
            <th
              scope="col"
              class="border-0"
              style="max-width: 200px;">Uwzględnione zamówienia</th>
            <th
              scope="col"
              class="border-0">Wartość faktury</th>
            <th
              scope="col"
              class="border-0 text-center">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded && settlements">
          <tr
            v-for="(settlement, index) of settlements"
            :key="'user-' + index">
            <td class="align-middle">
              {{ settlement.number === null ? 'Brak' : settlement.number }}
            </td>
            <td class="align-middle">
              <span class="text-success">{{ settlement.buyer_name }}</span>
              <span class="bottom-text">
                <span class="bottom-text-value">
                  <span class="text-secondary">Adres: </span>
                  <span class="text-semibold">{{settlement.buyer_city + ' ' + settlement.buyer_street}}</span><br>
                  <span class="text-secondary">NIP: </span>
                  <span class="text-semibold">{{ settlement.buyer_tax_no }}</span>
                </span>
              </span>
            </td>
            <td class="align-middle">
              {{ settlement.invoice_date }}
            </td>
            <td
              class="align-middle orders-list"
              style="width: 20%;">
              <span
                class="rwd-disabled"
                v-for="(order, orderIndex) in settlement.orders"
                :key="orderIndex">
                {{ order + ', '}}
              </span>
              <d-button
                class="rwd-tr-active"
                outline
                theme="success"
                :id="`popover-example-${settlement.id}`">
                <i class="material-icons">sticky_note_2</i>
                Zobacz
              </d-button>
              <d-popover
                :target="`popover-example-${settlement.id}`"
                container=".shards-demo--example--popover-01">
                <span
                  class="font-weight-normal"
                  v-for="(order, orderIndex) in settlement.orders"
                  v-if="settlement.orders.length"
                  :key="orderIndex">{{ order + ', '}}</span>
                <span
                  class="font-weight-normal"
                  v-if="!settlement.orders.length">Brak</span>
              </d-popover>
            </td>
            <td
              class="align-middle"
              style="min-width: 160px;">
              <small class="d-flex">
                Kwota: <strong class="ml-auto">{{ Number(settlement.amount).toFixed(2) }}&nbsp;zł</strong>
              </small>
              <small :class="Number(settlement.paid) < Number(settlement.amount) ? 'align-middle text-danger d-flex' : 'align-middle text-success d-flex'">
                Opłacono: <strong class="ml-auto">{{ Number(settlement.paid).toFixed(2) }}&nbsp;zł</strong>
              </small>
            </td>
            <td
              class="align-middle text-center"
              style="width: 150px;">
              <d-link
                :href="settlement.view_url"
                target="_blank">
                <d-button
                  :disabled="settlement.view_url === '' || settlement.view_url === null"
                  theme="info"
                  :class="{
                    'btn-icon my-2': true,
                    'isLoading': downloading === settlement.id
                  }"
                  outline>
                  <i class="material-icons">cloud_download</i>
                </d-button>
              </d-link>

              <d-button
                v-if="!settlement.paid_at"
                theme="warning"
                :class="{
                  'btn-icon ml-3 my-2': true,
                  'isLoading': isPaymentInProgress === settlement.id
                }"
                @click="submitSettlement(settlement.id)"
                :disabled="!!isPaymentInProgress">
                <i
                  class="material-icons"
                  style="transform: rotate(360deg);">euro_symbol</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="settlements.length === 0">
            <td
              colspan="8"
              class="text-center">
              Brak rozliczeń do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded || !settlements"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import DatePicker from 'vue2-datepicker';
import getMonths from '../../data/months-field';
import FilterAutocomplete from '../../components/others/filterAutocomplete.vue';
import SettlementsPayment from './SettlementsPayment.vue';
import PaymentMethods from '@/data/payments-methods.js';
import PaymentUtils from '@/utils/PaymentUtils';

export default {
  name: 'settlements',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    SettlementsPayment,
    FilterAutocomplete,
    DatePicker,
    'pagination': Pagination
  },
  data () {
    return {
      settlements: [],
      monthsList: getMonths(),
      loaded: false,
      load_error: false,
      remove_in_progress: false,
      show_payment_module: false,
      downloading: false,
      key_payment_module: 0,
      isPaymentInProgress: 0,
      submitting: {
        MONTHLY: false,
        WEEKLY: false,
        integrate: false
      },
      filters: {
        number: '',
        month: '',
        year: '',
        payment_type: '',
        customer_id: ''
      },
    };
  },
  computed: {
    paymentMethods () {
      return PaymentMethods;
    },
  },
  mounted () {
    this.loadFilteredData();
    this.getTime();
  },
  methods: {
    openModal () {
      this.show_payment_module = true;
    },
    closeModal () {
      this.show_payment_module = false;
      this.key_payment_module += 1;
    },
    refresh () {
      this.loadFilteredData();
      this.key_payment_module += 1;
    },
    getTime () {
      const now = new Date();
      const month = now.getMonth() + 1;
      const year = now.getFullYear();
      this.filters.month = month.toString();
      this.filters.year = year.toString();
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        number: this.filters.number
      };
      if (this.filters.month !== '') {
        where.month = this.filters.month;
      }
      if (this.filters.year !== '') {
        where.year = this.filters.year;
      }
      if (this.filters.customer_id !== '') {
        where.customer_id = this.filters.customer_id;
      }
      if (this.filters.payment_type.value !== '') {
        where.payment_type = this.filters.payment_type;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/settlements/items?page=' + this.currentPage,
        listField: 'settlements',
        errorKey: 'load_error',
        pagination: true,
        params: {
          where
        }
      });
    },
    generateSettlement (frequency) {
      this.submitting[frequency] = true;
      FormUtils.submit(this, {
        endpoint: 'settlements/generate',
        formData: {
          frequency
        },
        successTitle: 'Wygenerowano',
        successText: 'Poprawnie wygenerowano rozliczenie ' + (frequency === 'MONTHLY' ? 'miesięczne.' : 'tygodniowe.'),
        errorTitle: 'Wystąpił błąd',
        errorText: 'Generowanie rozliczenia nie powiodło się.<p class="mt-3 mb-2">Zweryfikuj zamówienia i spróbuj ponownie.</p>',
        successAction: () => {
          this.loaded = false;
          this.submitting[frequency] = false;
          this.loadFilteredData();
        },
        failAction: () => {
          this.submitting[frequency] = false;
        }
      });
    },
    integrateInvoices () {
      this.submitting.integrate = true;
      FormUtils.submit(this, {
        endpoint: 'settlements/integrate',
        successTitle: 'Wystawiono faktury',
        successText: 'Poprawnie wystawiono faktury <br />(zintegrowano rozliczenia z fakturownią).',
        successAction: () => {
          this.loaded = false;
          this.submitting.integrate = false;
          this.loadFilteredData();
        },
        failAction: () => {
          this.submitting.integrate = false;
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.load_error = false;
      this.filters = {
        number: '',
        month: '',
        year: '',
        payment_type: '',
        customer_id: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['settlements-filters-form'], this.debouncedLoadFilteredData);
    },
    submitSettlement (settlementID) {
      this.isPaymentInProgress = settlementID;

      PaymentUtils.submitExpressSettlement(this, {
        settlementID,
        successAction: () => {
          this.isPaymentInProgress = 0;
          this.debouncedLoadFilteredData();
        },
        failAction: () => {
          this.isPaymentInProgress = 0;
        },
        cancelAction: () => {
          this.isPaymentInProgress = 0;
        },
      });
    }
  }
};
</script>
<style lang="scss">
  .orders-list {
    max-width: 30%;
  }
  .my-collapse {
    position: absolute;
    width: 210px;
    z-index: 100;
    background-color: #fff;
    .rounded {
    }
  }
</style>

